import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root : {
        textAlign : 'center' 
    } ,
    image : {
        marginTop : 100,
        height : 80 ,
        width : 80
    } ,
    message : {
        paddingTop : 40
    }
}))
